import {Icon} from '@components/ui/icon'
import {FC} from 'react'
import {cn} from '@utilities/helpers'

interface CategoryCardProps {
    icon: Icon
    title: string
    description: string
    additionalComponent?: React.ReactNode
}
export const CategoryCard: FC<CategoryCardProps> = ({icon: Icon, title, description, additionalComponent}) => (
    <div
        className={cn(
            'flex flex-col gap-3 md:flex-row',
            '[&_h4]:text-lg [&_h4]:font-medium',
            '[&_p]:text-sm',
            '[&_svg]:fill-neutral-500'
        )}
    >
        <Icon />
        <div className="flex flex-col gap-1">
            <h4>{title}</h4>
            <p>{description}</p>
            {additionalComponent}
        </div>
    </div>
)
